import React, { useState } from 'react';
import { Box, Divider, Drawer, Grid, List, ListItem, ListItemButton, ListItemIcon, Toolbar, Typography } from '@mui/material'
import { Computer, Dashboard, PrintRounded, SupportAgentRounded, ContactMailRounded, MonitorHeartRounded } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { uiMovilOpenMenuAction } from '../../actions/equiposActions';



export const SideBar = ({ drawerWidth = 240 }) => {

    
    const dispatch = useDispatch();

    const { name } = useSelector( state => state.auth);

    const lastPath = localStorage.getItem('lastpath');
    
    const [selectedIndex, setSelectedIndex] = useState(lastPath);

    const handleDrawerToggle = (event, index) => {

        setSelectedIndex(index);

        dispatch( uiMovilOpenMenuAction() );

    };
    

    const { movilOpenMenu } = useSelector( state => state.ui);



    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
      };

  return (
    <Box
        component='nav'
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
    >
        <Drawer
            variant="temporary"
            open={movilOpenMenu}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{ 
                display: { xs: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth }
            }}
            // anchor='right'
        >
            <Toolbar>
                <Typography variant='h6' noWrap component='div'>
                    { name }
                </Typography>
            </Toolbar>
            <Divider />

            <List>
                
                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/home"
                        selected={selectedIndex === "/home"}
                        onClick={(event) => handleDrawerToggle(event, "/home")}
                    >
                        <ListItemIcon>
                            <Dashboard />
                        </ListItemIcon>
                        <Grid container>
                        Home
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/equipos"
                        selected={selectedIndex === "/equipos"}
                        onClick={(event) => handleDrawerToggle(event, "/equipos")}
                    >
                        <ListItemIcon>
                            <Computer />
                        </ListItemIcon>
                        <Grid container>
                        Equipos
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/equiposmainbit"
                        selected={selectedIndex === "/equiposmainbit"}
                        onClick={(event) => handleDrawerToggle(event, "/equiposmainbit")}
                    >
                        <ListItemIcon>
                            <Computer />
                        </ListItemIcon>
                        <Grid container>
                        Eq. Mainbit
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/imagenologia"
                        selected={selectedIndex === "/imagenologia"}
                        onClick={(event) => handleDrawerToggle(event, "/imagenologia")}
                    >
                        <ListItemIcon>
                            <MonitorHeartRounded />
                        </ListItemIcon>
                        <Grid container>
                        Eq. Imagenología
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/impresoras"
                        selected={selectedIndex === "/impresoras"}
                        onClick={(event) => handleDrawerToggle(event, "/impresorass")}
                    >
                        <ListItemIcon>
                            <PrintRounded />
                        </ListItemIcon>
                        <Grid container>
                        Impresoras
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/tickets"
                        selected={selectedIndex === "/tickets"}
                        onClick={(event) => handleDrawerToggle(event, "/tickets")}
                    >
                        <ListItemIcon>
                            <SupportAgentRounded />
                        </ListItemIcon>
                        <Grid container>
                        Tickets Soporte
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/cuentas"
                        selected={selectedIndex === "/cuentas"}
                        onClick={(event) => handleDrawerToggle(event, "/cuentas")}
                    >
                        <ListItemIcon>
                            <ContactMailRounded />
                        </ListItemIcon>
                        <Grid container>
                        Cuentas Inst.
                        </Grid>
                    </ListItemButton>
                </ListItem>
                   
            </List>

        </Drawer>
        <Drawer
          variant="permanent"
          onClose={handleDrawerToggle}
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        //   open
        >

        <Toolbar>
            <Typography variant='h6' noWrap component='div'>
                { name }
            </Typography>
        </Toolbar>
        
        <Divider />
         <List>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/home"
                        selected={selectedIndex === "/home"}
                        onClick={(event) => handleListItemClick(event, "/home")}
                    >
                        <ListItemIcon>
                            <Dashboard />
                        </ListItemIcon>
                        <Grid container>
                        Home
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/equipos"
                        selected={selectedIndex === "/equipos"}
                        onClick={(event) => handleListItemClick(event, "/equipos")}
                    >
                        <ListItemIcon>
                            <Computer />
                        </ListItemIcon>
                        <Grid container>
                        Equipos
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/equiposmainbit"
                        selected={selectedIndex === "/equiposmainbit"}
                        onClick={(event) => handleListItemClick(event, "/equiposmainbit")}
                    >
                        <ListItemIcon>
                            <Computer />
                        </ListItemIcon>
                        <Grid container>
                        Eq. Mainbit
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/imagenologia"
                        selected={selectedIndex === "/imagenologia"}
                        onClick={(event) => handleListItemClick(event, "/imagenologia")}
                    >
                        <ListItemIcon>
                            <MonitorHeartRounded />
                        </ListItemIcon>
                        <Grid container>
                        Eq. Imagenología
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/impresoras"
                        selected={selectedIndex === "/impresoras"}
                        onClick={(event) => handleListItemClick(event, "/impresorass")}
                    >
                        <ListItemIcon>
                            <PrintRounded />
                        </ListItemIcon>
                        <Grid container>
                        Impresoras
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/tickets"
                        selected={selectedIndex === "/tickets"}
                        onClick={(event) => handleListItemClick(event, "/tickets")}
                    >
                        <ListItemIcon>
                            <SupportAgentRounded />
                        </ListItemIcon>
                        <Grid container>
                        Tickets Soporte
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton
                        component={Link}
                        to="/cuentas"
                        selected={selectedIndex === "/cuentas"}
                        onClick={(event) => handleListItemClick(event, "/cuentas")}
                    >
                        <ListItemIcon>
                            <ContactMailRounded />
                        </ListItemIcon>
                        <Grid container>
                        Cuentas Inst.
                        </Grid>
                    </ListItemButton>
                </ListItem>

                <Divider />

            </List>

        </Drawer>

    </Box>
  )
}
